import React from "react"
import PropTypes from "prop-types"
import moment from 'moment'
import { semantic } from '@lexody/design-tokens'

import StandardButton from '../app_components/StandardButton'

function resolveAvatarUrl(avatarUrl) {
  if (!avatarUrl || avatarUrl.includes('missing')) {
    return null
  }
  return avatarUrl
}

class ConnectRequestItem extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      responded: false,
      accepted: false
    }

    this.renderTime = this.renderTime.bind(this)
    this.renderButtons = this.renderButtons.bind(this)
  }

  renderTime() {
    const today = moment(new Date())
    const expDate = moment(this.props.req.created_at).add(7, 'days')
    const diffTime = expDate.diff(today, 'hours')
    const days = Math.trunc(diffTime / 24)
    const hours = diffTime - (days * 24)
    return(`${days} day${days !== 1 ? 's' : ''} ${hours} hour${hours !== 1 ? 's' : ''}`)
  }

  acceptRequest() {
    this.setState({
      responded: true,
      accepted: true
    })

    $.ajax({
      url: `../acceptConnect`,
      dataType: 'JSON',
      type: 'POST',
      data: { id: this.props.req.id },
      header: {
        'Content-Type': 'application/json'
      },
      success: () => {},
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    })
  }

  denyRequest() {
    this.setState({
      responded: true,
      accepted: false
    })

    $.ajax({
      url: `../declineConnect`,
      dataType: 'JSON',
      type: 'POST',
      data: { id: this.props.req.id },
      header: {
        'Content-Type': 'application/json'
      },
      success: () => {},
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    })
  }

  renderButtons() {
    const { requestor } = this.props.req

    if (this.state.responded !== true) {
      return(
        <div className="connectsRequestCard__actions">
          <p className="connectsRequestCard__expiry">Expires in {this.renderTime()}</p>
          <div className="connectsRequestCard__actionRow">
            <StandardButton text="Decline" size="small" primary={false} alert={true} onClick={() => this.denyRequest()} />
            <StandardButton text="Accept" size="small" primary={true} onClick={() => this.acceptRequest()} />
          </div>
        </div>
      )
    }

    if (this.state.accepted === true) {
      return (
        <div className="connectsRequestCard__actions">
          <p className="connectsRequestCard__result">
            You are now connected to {requestor.preferred_name}!
          </p>
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: 12 }}>
            <StandardButton
              text={`Go to ${requestor.preferred_name}'s Profile`}
              size="small"
              primary={true}
              onClick={() => window.location.assign(`/profile/${requestor.slug}`)}
            />
          </div>
        </div>
      )
    }

    return (
      <p className="connectsRequestCard__result">
        You declined connecting with {requestor.preferred_name}.
      </p>
    )
  }

  render() {
    const avatarUrl = resolveAvatarUrl(this.props.req.requestor.avatar_url) || this.props.req.requestor.avatar_url

    return(
      <article className="connectsRequestCard">
        <div className="connectsRequestCard__top">
          <button
            type="button"
            className="connectsRequestCard__avatar"
            onClick={() => window.location.assign(`/profile/${this.props.req.requestor.slug}`)}
          >
            <img src={avatarUrl} alt="" />
          </button>
          <div className="connectsRequestCard__body">
            <p className="connectsRequestCard__message">{this.props.req.msg}</p>
          </div>
        </div>
        {this.renderButtons()}
      </article>
    )
  }
}

ConnectRequestItem.propTypes = {
  req: PropTypes.object.isRequired,
}

export default ConnectRequestItem
